import { IndustryState } from './industry-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';

import { Action, StateStatus } from './utils/state-manager';

const InitialState: IndustryState = {
  industries: null,
  industriesState: StateStatus.notAttempted,
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_INDUSTRIES'): {
      return {
        ...state,
        industriesState: StateStatus.loading,
      };
    }
    case SUCCESS('LOAD_INDUSTRIES'): {
      return {
        industries: action.payload.data,
        industriesState: StateStatus.success,
      };
    }
    case FAILURE('LOAD_INDUSTRIES'): {
      return {
        ...state,
        industriesState: StateStatus.error,
      };
    }
    default:
      return state;
  }
};
